const ExportIcon = ({ color }: { color?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99023 4.87508L8.91023 2.95508L10.8302 4.87508"
        stroke={color ? color : '#F6FCFF'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.91016 10.6353V3.00781"
        stroke={color ? color : '#F6FCFF'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9C3 12.315 5.25 15 9 15C12.75 15 15 12.315 15 9"
        stroke={color ? color : '#F6FCFF'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExportIcon;
